"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ACTION_VIEW;
(function (ACTION_VIEW) {
    ACTION_VIEW["text"] = "text";
    ACTION_VIEW["primary"] = "primary";
    ACTION_VIEW["secondary"] = "secondary";
    ACTION_VIEW["alternate"] = "alternate";
})(ACTION_VIEW = exports.ACTION_VIEW || (exports.ACTION_VIEW = {}));
var DIALOG_SIZE;
(function (DIALOG_SIZE) {
    DIALOG_SIZE["xxs"] = "xxs";
    DIALOG_SIZE["xs"] = "xs";
    DIALOG_SIZE["s"] = "s";
    DIALOG_SIZE["m"] = "m";
    DIALOG_SIZE["l"] = "l";
    DIALOG_SIZE["xl"] = "xl";
    DIALOG_SIZE["xxl"] = "xxl";
    DIALOG_SIZE["auto"] = "auto";
})(DIALOG_SIZE = exports.DIALOG_SIZE || (exports.DIALOG_SIZE = {}));
//# sourceMappingURL=types.js.map